"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _label_tooltip = _interopRequireDefault(require("./label_tooltip"));
var _constants = require("../../constants");
var _icons = require("../../icons");
var _style_injectors = require("./style_injectors");
var _styledComponents = require("styled-components");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DescriptionTooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DescriptionTooltip, _React$Component);
  var _super = _createSuper(DescriptionTooltip);
  function DescriptionTooltip() {
    (0, _classCallCheck2["default"])(this, DescriptionTooltip);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(DescriptionTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        text = _this$props.text,
        position = _this$props.position,
        interactive = _this$props.interactive,
        children = _this$props.children,
        styles = _this$props.styles;
      var DescriptionTheme = (0, _style_injectors.injectDescriptionTheme)(theme, styles);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DescriptionTheme, null), /*#__PURE__*/React.createElement(_label_tooltip["default"], {
        theme: "information",
        text: text,
        position: position,
        hideOnClick: false,
        interactive: interactive
      }, children || /*#__PURE__*/React.createElement(_icons.InformationIcon, {
        hoverColor: _constants.colors.mediumGrey
      })));
    }
  }]);
  return DescriptionTooltip;
}(React.Component);
DescriptionTooltip.propTypes = {
  text: _propTypes["default"].string.isRequired,
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  interactive: _propTypes["default"].bool,
  styles: _propTypes["default"].any
};
DescriptionTooltip.defaultProps = {
  position: 'bottom',
  styles: {
    width: '200px'
  }
};
var ThemedDescriptionTooltip = (0, _styledComponents.withTheme)(DescriptionTooltip);
var _default = ThemedDescriptionTooltip;
exports["default"] = _default;